<template>
  <div id="liga-sekolah-brackets">
		<ol class="breadcrumb pull-right">
      <li><router-link :to="{path: '/'}">Home</router-link></li>
      <li>Duel</li>
      <li class="active"><router-link :to="{path: '/liga-sekolah'}">Menu Liga Sekolah</router-link></li>
      <li class="active">Brackets</li>
    </ol>
    <!-- begin page-header -->
    <!-- begin page-header -->
    <h1 class="page-header">Bracket</h1>
    <!-- end page-header -->

    <div>
			<bracket :rounds="rounds">
				<template #player="{ player }">
					{{ player.name }}
				</template>
				<template #player-extension-bottom="{ match }">
					Extra info: {{ match.title }}
				</template>
			</bracket>
    </div>
  </div>
</template>

<script>
import Bracket from "vue-tournament-bracket"

export default {
	name: 'liga-sekolah-menu',
	components: {
		"bracket": Bracket
	},
	data() {
		return {
			rounds: [
				//Semi finals
				{
					games: [
						{
							player1: { id: "1", name: "Competitor 1", winner: false },
							player2: { id: "4", name: "Competitor 4", winner: true },
						},
						{
							player1: { id: "3", name: "Competitor 5", winner: false },
							player2: { id: "9", name: "Competitor 8", winner: true },
						},
						{
							player1: { id: "6", name: "Competitor 5", winner: false },
							player2: { id: "2", name: "Competitor 8", winner: true },
						},
					]
				},
				//Final
				{
					games: [
						{
							player1: { id: "4", name: "Competitor 4", winner: false },
							player2: { id: "8", name: "Competitor 8", winner: true },
						},
						{
							player1: { id: "3", name: "Competitor 4", winner: false },
							player2: { id: "6", name: "Competitor 8", winner: true },
						},
					]
				}
			]
		}
	}
}
</script>


// WEBPACK FOOTER //
// LigaSekolahBrackets.vue?007f5052